import { useState } from 'react';
import { ShoppingCart, Loader2 } from 'lucide-react';
import { useCart } from '../hooks/useCart';

interface AddToCartButtonProps {
  productId: string;
  quantity?: number;
  className?: string;
  showIcon?: boolean;
  showText?: boolean;
  onSuccess?: () => void;
  onError?: (error: string) => void;
}

export default function AddToCartButton({
  productId,
  quantity = 1,
  className = '',
  showIcon = true,
  showText = true,
  onSuccess,
  onError
}: AddToCartButtonProps) {
  const { loading, addToCart } = useCart({
    onSuccess,
    onError
  });

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault(); // Prevenir navegación en caso de estar dentro de un enlace
    e.stopPropagation(); // Prevenir propagación al Link padre
    await addToCart(productId, quantity);
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading}
      className={`bg-blue-600 text-white px-3 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {loading ? (
        <>
          <Loader2 className="w-4 h-4 animate-spin" />
          {showText && <span>Agregando...</span>}
        </>
      ) : (
        <>
          {showIcon && <ShoppingCart className="w-4 h-4" />}
          {showText && <span>Añadir al carrito</span>}
        </>
      )}
    </button>
  );
} 